export const MB = 1000000;
export const KB = MB / 1000;

export const MEDIA_TYPE = {
    IMAGE: 1,
    VIDEO: 2,
};
